var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 44,
    viewBox: "0 0 46 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9766 3.77726C37.6085 1.2761 30.2403 0 22.9232 0C15.6062 0 8.28921 1.2761 1.07453 3.77726L0 4.18562L0.153504 5.30858C1.1257 12.0974 2.96774 18.0696 5.83315 23.5824C9.56841 30.8306 14.9922 37.4664 22.1046 43.2854L22.9744 44L23.8443 43.2854C31.059 37.4664 36.4828 30.7796 40.1669 23.5824C42.9811 18.0186 44.8743 12.0464 45.8465 5.30858L46 4.18562L44.9766 3.77726ZM41.6507 5.66589L23.0256 20.9791L4.40044 5.66589C10.5406 3.82831 16.7831 2.85847 22.9232 2.85847C29.1146 2.80742 35.4082 3.77726 41.6507 5.66589ZM23.0256 40.478C9.77308 29.1462 5.37264 17.4571 3.58176 8.57541L23.0256 24.5522L42.4694 8.57541C40.6785 17.4571 36.2781 29.1462 23.0256 40.478Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/es.160ee80a8589324046cc35841921bdf6.svg";
export { ForwardRef as ReactComponent };